import React from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import CredfinFavicon from '../images/credfinfav.jpeg'
import AbhicashFavicon from '../images/AbhicashFav.png'
import CredfinLogo from '../images/credfinlogo.png'
import AbhicashLogo from '../images/AbhicashLogo.png'
import CredfinLightLogo from '../images/credfin.png'
import creditJarLogoDark from '../images/creditJarLogo.svg'
import creditjarFavicon from '../images/creditjarFavicon.svg'

import cashbridgeLogoWhite from '../images/cashbridgeLogoWhite.svg'
import cashbridgeFavicon2 from '../images/cashbridgeFavicon2.svg'
import favicontap4loan from '../images/favicontap4loan.svg'
import Tap4Loanwhite from '../images/Tap4Loanwhite.svg'
import Tap4loan from '../images/Tap4loan.svg'
import faviconfinebucks from '../images/faviconfinebucks.png'
import FinebucksLogo from '../images/FinebucksLogo.svg'

const TENANT_CONFIGS = {

  'internal.credfin.money': {
    COMPANY_NAME: "Credfin",
    COMPANY_NAME_CAPS: "CREDFIN",
    COMPANY_NAME_SMALLCASE: "credfin",
    BASE_URL: 'https://backend.credfin.money/',
    FRONTEND_BASE_URL: 'https://internal.credfin.money/',
    LLM_BASE_URL: 'https://llmbackend.infitouch.in/',
    LEADDASHBOARD_URL: 'https://leaddashboard.credfin.money/',
    TENANT_ID: 'cf',
    ESIGN_KEY: "arhamfinance&investmentservicesltd_esign_live",
    WEB_URL: 'https://internal.credfin.money/',
    MSITE_URL: 'https://msite.credfin.money/',
    TITLE: "Loans made Easy",
    FAVICON: CredfinFavicon,
    LOGO: CredfinLogo,
    LIGHT_LOGO: CredfinLightLogo,
    HEADER_LOGO_WIDTH: "80px",
    RootcssClassName: "credfin-css",
    BOSS_EMAILID: "mohit.bansal@credfin.money",
    NBFC_NAME_TO_SHOW: "Arham",
    REPORT_DB_KEY: "credfin",
    ADMIN_URL_STRING_SHORT: "credfin.money",
    ADMIN_URL_STRING_SHORT_FULL_URL: "internal.credfin.money",
    NBFC_SHORT: "Arham",
    WEBSITE_URL: "https://credfin.money",
    ACCOUNT_DETAILS: {
      COMPANY_NAME: 'Name : Arham Finance and Investment Services Ltd',
      BANK_NAME: 'Bank : ICICI BANK LTD',
      BRANCH_NAME: 'Branch : 112, DAYANAND ROAD, DARYAGANJ, NEW DELHI-11,NEWDELHI,110002',
      ACCOUNT_NUMBER: 'A/C : 033305006690',
      IFSC_CODE: 'ifsc code : ICIC0000333',
      NBFC_NAME: "Arham Finance and Investment Services Ltd",
    },
    MAIL_STRING: {
      WEB_URL_NACH: "https://drive.google.com/open?id=1BicYQIO5j7GKmLOqtsNIMLylFnfbKpNU",
      WEB_URL: "https://internal.credfin.money/uploadDocuments/",
      ACCOUNT_AGGREGATOR_URL: "https://internal.credfin.money/AccountAggregatorLink/",
      MOBILE_NO: "+91-9311226661",
      WHATSAPP: "+91-9311226661",
      EMAIL_ID: "recovery@credfin.money",
      FINANCE_MAIL_ID: "finance@credfin.money",
      SUPPORT_MAIL_ID: "support@credfin.money",
      KYC_URL: 'https://internal.crefin.money/kyc/',
      CONFIG_MAIL_ID: "config@credfin.money",
      RECOVERY_MAIL_ID: "recovery@credfin.money",
      APP_LINK: "app.credfin.money/cash",
    },
    SECURITY_CHEQUE_ADDRESS: {
      COMPANY_NAME: "Credfin Infotech Pvt. Ltd.",
      ADDRESS: "1401,1403, Building No. 43, Chiranjiv Tower",
      AREA: "Opposite Eros Hotel, Nehru Place",
      CITY: "New Delhi- 110019."
    }

  },
  'admin.abhicash.in': {
    COMPANY_NAME: "Abhicash",
    COMPANY_NAME_CAPS: "ABHICASH",
    COMPANY_NAME_SMALLCASE: "abhicash",
    BASE_URL: 'https://backend.abhicash.in/',
    FRONTEND_BASE_URL: 'https://admin.abhicash.in/',
    LLM_BASE_URL: 'https://llmbackend.infitouch.in/',
    TENANT_ID: 'ac',
    ESIGN_KEY: "phocket-infotech-private-limited_esign_production",
    MSITE_URL: 'https://uat.abhicash.in/',
    WEB_URL: 'https://admin.abhicash.in/',
    TITLE: "Instant Loans and Financial Wellness Solutions",
    FAVICON: AbhicashFavicon,
    LOGO: AbhicashLogo,
    LIGHT_LOGO: AbhicashLogo,
    HEADER_LOGO_WIDTH: "80px",
    RootcssClassName: "Abhicash-css",
    BOSS_EMAILID: "mohit.bansal@abhicash.in",
    NBFC_NAME_TO_SHOW: "CNMP",
    REPORT_DB_KEY: "abhicash",
    ADMIN_URL_STRING_SHORT: "abhicash.in",
    ADMIN_URL_STRING_SHORT_FULL_URL: "admin.abhicash.in",
    NBFC_SHORT: "CNMP",
    WEBSITE_URL: "https://abhicash.in",
    ACCOUNT_DETAILS: {
      COMPANY_NAME: 'Name : CNMP Investments Private Limited',
      BANK_NAME: 'Bank : HDFC, Delhi',
      BRANCH_NAME: 'Branch : CONNAUGHT PLACE',
      ACCOUNT_NUMBER: 'A/C : 50200072791180',
      IFSC_CODE: 'ifsc code : HDFC0001563',
      NBFC_NAME: "CNMP Investments Private Limited",
    },
    MAIL_STRING: {
      WEB_URL_NACH: "https://drive.google.com/open?id=1BicYQIO5j7GKmLOqtsNIMLylFnfbKpNU",
      WEB_URL: "https://admin.abhicash.in/uploadDocuments/",
      ACCOUNT_AGGREGATOR_URL: "https://admin.abhicash.in/AccountAggregatorLink/",
      // MOBILE_NO: "+91-9220320064",
      // MOBILE_NO: "08047861605",
      MOBILE_NO: "9999966040",
      WHATSAPP: "9999966040",
      EMAIL_ID: "recovery@abhicash.in",
      FINANCE_MAIL_ID: "finance@abhicash.in",
      SUPPORT_MAIL_ID: "support@abhicash.in",
      KYC_URL: 'https://admin.abhicash.in/kyc/',
      CONFIG_MAIL_ID: "config@abhicash.in",
      RECOVERY_MAIL_ID: "recovery@abhicash.in",
      APP_LINK: "app.abhicash.in/cash",
    },
    SECURITY_CHEQUE_ADDRESS: {
      COMPANY_NAME: "Abhicash Infotech Pvt. Ltd.",
      ADDRESS: "410, Enkay Center, Vanijya Nikunj,",
      AREA: "WING A, Plot No A, Udyog Vihar, Phase-V,",
      CITY: "Gurugram, Haryana-122016"
    }

  },
  'admin.creditjar.in': {
    COMPANY_NAME: "Creditjar",
    COMPANY_NAME_CAPS: "CREDITJAR",
    COMPANY_NAME_SMALLCASE: "creditjar",
    BASE_URL: 'https://backend.creditjar.in/',
    FRONTEND_BASE_URL: 'https://admin.creditjar.in/',
    LLM_BASE_URL: 'https://llmbackend.infitouch.in/',
        LEADDASHBOARD_URL: 'https://leaddashboard.creditjar.in/',
    TENANT_ID: 'cj',
    ESIGN_KEY: "phocket-infotech-private-limited_esign_production",
    MSITE_URL: 'https://uat.creditjar.in/',
    WEB_URL: 'https://admin.creditjar.in/',
    TITLE: "Get quick, hassle-free funds Designed to meet urgent needs",
    FAVICON: creditjarFavicon,
    LOGO: creditJarLogoDark,
    LIGHT_LOGO: creditJarLogoDark,
    HEADER_LOGO_WIDTH: "100px",
    RootcssClassName: "Creditjar-css",
    BOSS_EMAILID: "mohit.bansal@creditjar.in",
    NBFC_NAME_TO_SHOW: "D.S. Integrated",
    REPORT_DB_KEY: "creditjar",
    ADMIN_URL_STRING_SHORT: "creditjar.in",
    ADMIN_URL_STRING_SHORT_FULL_URL: "admin.creditjar.in",
    NBFC_SHORT: "D.S. Integrated",
    WEBSITE_URL: "https://creditjar.in",
    ACCOUNT_DETAILS: {
      COMPANY_NAME: 'Name : D.S.INTEGRATED FINSEC PRIVATE LIMITED ',
      BANK_NAME: 'Bank : ICICI BANK LTD',
      BRANCH_NAME: 'Branch : RAJKOT - GONDAL ROAD',
      ACCOUNT_NUMBER: 'A/C : 072805003919',
      IFSC_CODE: 'ifsc code : ICIC0000728',
      NBFC_NAME: "D.S. Integrated Finsec Private Limited",
    },
    MAIL_STRING: {
      WEB_URL_NACH: "https://drive.google.com/open?id=1BicYQIO5j7GKmLOqtsNIMLylFnfbKpNU",
      WEB_URL: "https://admin.creditjar.in/uploadDocuments/",
      ACCOUNT_AGGREGATOR_URL: "https://admin.creditjar.in/AccountAggregatorLink/",
      // MOBILE_NO: "+91-9220320064",
      MOBILE_NO: "9876543219",
      WHATSAPP: "9978707807",
      EMAIL_ID: "recovery@Creditjar.in",
      FINANCE_MAIL_ID: "finance@Creditjar.in",
      SUPPORT_MAIL_ID: "support@Creditjar.in",
      KYC_URL: 'https://admin.creditjar.in/kyc/',
      CONFIG_MAIL_ID: "config@Creditjar.in",
      RECOVERY_MAIL_ID: "recovery@Creditjar.in",
      APP_LINK: "app.Creditjar.in/cash",
    },
    SECURITY_CHEQUE_ADDRESS: {
      COMPANY_NAME: "D.S. Integrated Finsec Private Limited",
      ADDRESS: "OPP ANDH MAHILA VIKAS GRUH, ARIHANT,SHRAMJIVI SOCIETY,",
      AREA: " DHEBAR ROAD, RAJKOT,",
      CITY: "Rajkot, Gujarat, 360002"
    }

  },
  'admin.cashbridge.in': {
    COMPANY_NAME: "Cashbridge", //done
    COMPANY_NAME_CAPS: "CASHBRIDGE", //done
    COMPANY_NAME_SMALLCASE: "cashbridge", //done
    BASE_URL: 'https://backend.cashbridge.in/',
    FRONTEND_BASE_URL: 'https://admin.cashbridge.in/',
    LLM_BASE_URL: 'https://llmbackend.infitouch.in/',
     LEADDASHBOARD_URL: 'https://leaddashboard.cashbridge.in/',
    TENANT_ID: 'cb',
    ESIGN_KEY: "phocket-infotech-private-limited_esign_production",
    WEB_URL: 'https://admin.cashbridge.in/',
    MSITE_URL: 'https://loan.cashbridge.in/',
    TITLE: "Get quick, hassle-free funds Designed to meet urgent needs",
    FAVICON: cashbridgeFavicon2,
    LOGO: cashbridgeLogoWhite,
    LIGHT_LOGO: cashbridgeLogoWhite,
    HEADER_LOGO_WIDTH: "120px",
    RootcssClassName: "Cashbridge-css",
    BOSS_EMAILID: "mohit.bansal@cashbridge.in",
    NBFC_NAME_TO_SHOW: "Rachit Capital Services",
    REPORT_DB_KEY: "cashbridge",
    ADMIN_URL_STRING_SHORT: "cashbridge.in",
    ADMIN_URL_STRING_SHORT_FULL_URL: "admin.cashbridge.in",
    NBFC_SHORT: "Rachit Capital Services",
    WEBSITE_URL: "https://cashbridge.in",
    ACCOUNT_DETAILS: {
      COMPANY_NAME: 'Name : Rachit Capital Services Private limited',
      BANK_NAME: 'Bank : ICICI BANK LTD',
      BRANCH_NAME: 'Branch : GURGAON - SECTOR 14',
      ACCOUNT_NUMBER: 'A/C : 002105030854',
      IFSC_CODE: 'ifsc code : ICIC0000021',
      NBFC_NAME: "Rachit Capital Services Privated Limited",
    },
    MAIL_STRING: {
      WEB_URL_NACH: "https://drive.google.com/open?id=1BicYQIO5j7GKmLOqtsNIMLylFnfbKpNU",
      WEB_URL: "https://admin.cashbridge.in/uploadDocuments/",
      ACCOUNT_AGGREGATOR_URL: "https://admin.cashbridge.in/AccountAggregatorLink/",
      // MOBILE_NO: "+91-9220320064",
      // MOBILE_NO: "9876543219",
      MOBILE_NO: "9217916736",
      WHATSAPP: "9217916736",
      EMAIL_ID: "recovery@cashbridge.in",
      FINANCE_MAIL_ID: "finance@cashbridge.in",
      SUPPORT_MAIL_ID: "support@cashbridge.in",
      KYC_URL: 'https://admin.cashbridge.in/kyc/',
      CONFIG_MAIL_ID: "config@cashbridge.in",
      RECOVERY_MAIL_ID: "recovery@cashbridge.in",
      APP_LINK: "app.cashbridge.in/cash",
    },
    SECURITY_CHEQUE_ADDRESS: {
      COMPANY_NAME: "Rachit Capital Services Privated Limited",
      ADDRESS: "Vipul Plaza, ",
      AREA: "Sector 81,",
      CITY: "Faridabad, Haryana - 121002"
    }

  },
  'admin.tap4loan.com': {
    COMPANY_NAME: "Tap4Loan", //done
    COMPANY_NAME_CAPS: "TAP4LOAN", //done
    COMPANY_NAME_SMALLCASE: "tap4loan", //done
    BASE_URL: 'https://backend.tap4loan.com/',
    // BASE_URL: 'https://backend.cashbridge.in/',
    FRONTEND_BASE_URL: 'https://admin.tap4loan.com/',
    LLM_BASE_URL: 'https://llmbackend.infitouch.in/',
    TENANT_ID: 'GOLU',
    ESIGN_KEY: "phocket-infotech-private-limited_esign_production",
    WEB_URL: 'https://admin.tap4loan.com/',
    MSITE_URL: 'https://loan.tap4loan.com/',
    TITLE: "Instant personal loans with paperless processing",
    FAVICON: favicontap4loan,
    LOGO: Tap4loan,
    LIGHT_LOGO: Tap4Loanwhite,
    HEADER_LOGO_WIDTH: "100px",
    RootcssClassName: "Tap4Loan-css",
    BOSS_EMAILID: "mohit.bansal@tap4loan.in",
    NBFC_NAME_TO_SHOW: "GOLU LEASING & FINANCE CO. PRIVATE LIMITED",
    REPORT_DB_KEY: "tap4loan",
    ADMIN_URL_STRING_SHORT: "tap4loan.com",
    ADMIN_URL_STRING_SHORT_FULL_URL: "admin.tap4loan.com",
    NBFC_SHORT: "GOLU LEASING & FINANCE",
    WEBSITE_URL: "https://tap4loan.com",
    ACCOUNT_DETAILS: {
      COMPANY_NAME: 'Name : GOLU LEASING & FINANCE CO. PRIVATE LIMITED (COLLECTION)',
      BANK_NAME: 'Bank : ICICI Bank',
      BRANCH_NAME: 'Branch : Green Park',
      ACCOUNT_NUMBER: 'A/C : 007105012699',
      IFSC_CODE: 'ifsc code : ICIC0000071',
      NBFC_NAME: "GOLU LEASING & FINANCE CO. PRIVATE LIMITED",
    },
    MAIL_STRING: {
      WEB_URL_NACH: "https://drive.google.com/open?id=1BicYQIO5j7GKmLOqtsNIMLylFnfbKpNU",
      WEB_URL: "https://admin.tap4loan.com/uploadDocuments/",
      ACCOUNT_AGGREGATOR_URL: "https://admin.tap4loan.com/AccountAggregatorLink/",
      MOBILE_NO: "",
      WHATSAPP: "",
      EMAIL_ID: "support@golufin.com",
      FINANCE_MAIL_ID: "compliance@golufin.com",
      SUPPORT_MAIL_ID: "support@golufin.com",
      KYC_URL: 'https://admin.tap4loan.com/kyc/',
      CONFIG_MAIL_ID: "admin@golufin.com",
      RECOVERY_MAIL_ID: "admin@golufin.com",
      APP_LINK: "",
    },
    SECURITY_CHEQUE_ADDRESS: {
      COMPANY_NAME: "SVR TECH SOLUTIONS PRIVATE LIMITED",
      ADDRESS: "B-7/106A, SAFDARJUNG ENCLAVE EXTN., Nauroji Nagar, New Delhi - 110029, ",
      AREA: "New Delhi,",
      CITY: "New Delhi"
    }

  },
  'frontend.finebucks.money': {
    COMPANY_NAME: "Finebucks", //done
    COMPANY_NAME_CAPS: "FINEBUCKS", //done
    COMPANY_NAME_SMALLCASE: "finebucks", //done
    BASE_URL: 'https://backend.finebucks.money/',
    FRONTEND_BASE_URL: 'https://frontend.finebucks.money/',
    LLM_BASE_URL: 'https://llmbackend.infitouch.in/',
    TENANT_ID: 'fb',
    ESIGN_KEY: "phocket-infotech-private-limited_esign_production",
    WEB_URL: 'https://frontend.finebucks.money/',
    MSITE_URL: 'https://loan.finebucks.money/',
    TITLE: "Loans Considered & Approved in minutes",
    FAVICON: faviconfinebucks,
    LOGO: FinebucksLogo,
    LIGHT_LOGO: FinebucksLogo,
    HEADER_LOGO_WIDTH: "100px",
    RootcssClassName: "Finebucks-css",
    BOSS_EMAILID: "mohit.bansal@finebucks.money",
    NBFC_NAME_TO_SHOW: "D.S. Integrated Finsec Private Limited",
    REPORT_DB_KEY: "finebucks",
    ADMIN_URL_STRING_SHORT: "finebucks.money",
    ADMIN_URL_STRING_SHORT_FULL_URL: "frontend.finebucks.money",
    NBFC_SHORT: "D.S. Integrated Finsec",
    WEBSITE_URL: "https://finebucks.money",
    ACCOUNT_DETAILS: {
      COMPANY_NAME: 'Name : PARTHV TECHNOLOGIES PRIVATE LIMITED',
      BANK_NAME: 'Bank : ICICI',
      BRANCH_NAME: 'Branch : Rajkot - Gondal Road',
      ACCOUNT_NUMBER: 'A/C : 777705220265',
      IFSC_CODE: 'ifsc code : ICIC0000728',
      NBFC_NAME: "D.S. INTEGRATED FINSEC PRIVATE LIMITED",
    },
    MAIL_STRING: {
      WEB_URL_NACH: "https://drive.google.com/open?id=1BicYQIO5j7GKmLOqtsNIMLylFnfbKpNU",
      WEB_URL: "https://frontend.finebucks.money/uploadDocuments/",
      ACCOUNT_AGGREGATOR_URL: "https://frontend.finebucks.money/AccountAggregatorLink/",
      MOBILE_NO: "",
      WHATSAPP: "",
      EMAIL_ID: "support@finebucks.money",
      FINANCE_MAIL_ID: "finance@finebucks.money",
      SUPPORT_MAIL_ID: "support@finebucks.money",
      KYC_URL: 'https://frontend.finebucks.money/kyc/',
      CONFIG_MAIL_ID: "config@finebucks.money",
      RECOVERY_MAIL_ID: "recovery@finebucks.money",
      APP_LINK: "",
    },
    SECURITY_CHEQUE_ADDRESS: {
      COMPANY_NAME: "PARTHV TECHNOLOGIES PRIVATE LIMITED",
      ADDRESS: "UNIT NO. C-623, 6TH FLOOR, VIPUL PLAZA, ",
      AREA: "SECTOR 81, ",
      CITY: "FARIDABAD, HARYANA, INDIA - 121004 "
    }

  },
};


const TENANT_URLS = {
  cf: {
    // frontend: 'https://admin.credfin.money/',
    frontend: 'https://internal.credfin.money/',
    backend: 'https://backend.credfin.money/',
  },
  ac: {
    frontend: 'https://admin.abhicash.in/',
    backend: 'https://backend.abhicash.in/',
  },
  cj: {
    frontend: 'https://admin.creditjar.in/',
    backend: 'https://backend.creditjar.in/',
  },
  cb: {
    frontend: 'https://admin.cashbridge.in/',
    backend: 'https://backend.cashbridge.in/',
  },
  ct: {
    frontend: 'https://frontend.cashtap.in/',
    backend: 'https://backend.cashtap.in/',
  },
  GOLU: {
    frontend: 'https://admin.tap4loan.com/',
    backend: 'https://backend.tap4loan.com/',
  },
  fb: {
    frontend: 'https://frontend.finebucks.money/',
    backend: 'https://backend.finebucks.money/',
  },
}

const handleURL = () => {
  const link = window.location?.host;
  // const link = "admin.credfin.money";
  // const link = "internal.credfin.money";
  // const link = "admin.micromoney.in";
  // const link = "adminu.micromoney.in";
  // const link = "admin.abhicash.in";
  // const link = "admin.creditjar.in";
  // const link = "admin.cashbridge.in";
  // const link = "admin.tap4loan.com";
  // const link = "frontend.finebucks.money";
  return link
}

const InvalidTenantPage = () => (
  <div style={{ padding: '2rem', textAlign: 'center', margin: '10% 15px' }}>
    <h1>Invalid URL</h1>
    <p>This domain is not configured for access. Please Contact the Developer</p>
  </div>
);

export const Company_DATA = {
  CREDFIN: "Credfin",
  MICROMONEY: "Micromoney",
  ABHICASH: "Abhicash",
  CREDITJAR: "Creditjar",
  CASHBRIDGE: "Cashbridge",
  TAP4LOAN: "Tap4Loan",
  FINEBUCKS: "Finebucks",
}

export const CheckFunction = () => {
  const url = handleURL();
  const tenantConfig = TENANT_CONFIGS[url]
  if (!tenantConfig) {
    return ""
  }
  return tenantConfig
}


const MainFunction = () => {
  const dispatch = useDispatch()

  const url = handleURL();

  const tenantConfig = TENANT_CONFIGS[url]

  if (!tenantConfig) {

    return <InvalidTenantPage />;
  }

  dispatch({ type: 'SET_ACTIVE_TENANT', payload: tenantConfig });
  document.title = tenantConfig.TITLE || "";

  const rootElement = document.getElementById('phocketApp');
  if (rootElement) {
    rootElement.classList.add(tenantConfig?.RootcssClassName);
  }


  const favicon = document.querySelector('link[rel="shortcut icon"]') ||
    document.createElement('link');
  favicon.rel = 'icon';
  favicon.type = 'image/png';
  favicon.href = tenantConfig.FAVICON || "";
  if (!document.querySelector('link[rel="icon"]')) {
    document.head.appendChild(favicon);
  }


  return <Outlet />;

}

export default MainFunction;

export const CREDFIN_LIKE = [Company_DATA?.CREDFIN]
export const MICROMONEY_LIKE = [Company_DATA?.MICROMONEY]
export const ABHICASH_ONLY = [Company_DATA?.ABHICASH]
export const ABHICASH_LIKE = [Company_DATA?.ABHICASH, Company_DATA?.CREDITJAR, Company_DATA?.CASHBRIDGE]
export const CREDITJAR_LIKE = [Company_DATA?.CREDITJAR]
export const CASHBRIDGE_ONLY = [Company_DATA?.CASHBRIDGE]
export const CASHBRIDGE_LIKE = [Company_DATA?.CASHBRIDGE, Company_DATA?.TAP4LOAN, Company_DATA?.FINEBUCKS]
export const TAP4LOAN_LIKE = [Company_DATA?.TAP4LOAN]
export const FINEBUCKS_LIKE = [Company_DATA?.FINEBUCKS]


export const CHECK_COMPANY_TENANT = (arr) => {
  const tenant = CheckFunction();
  if (arr?.includes(tenant?.COMPANY_NAME)) {
    return true
  }
  return false
}

export const TENANT_BASED_URL = (tenantId, urlType) => {
  if (TENANT_URLS && TENANT_URLS?.[tenantId]) {
    if (urlType != "") {
      return TENANT_URLS?.[tenantId]?.[urlType]
    } else {
      return TENANT_URLS?.[tenantId]
    }
  } else {
    return false
  }
}